"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = require("../../../_util/index");
var useConfig_1 = __importDefault(require("../../../_util/useConfig"));
function AnimSme() {
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    (0, react_1.useEffect)(function () {
        (0, index_1.windowAddEventListener)(function () {
            (0, index_1.scaleAnimation)('sme-animation-fake');
        }, 1);
    }, []);
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "-sme-anim"), id: 'sme-animation-fake' },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: {
                    background: 'url(https://staticintl.cloudcachetci.com/cms/backend-cms/5Ynx613_03-tuya.png)',
                }, className: "sme-anim--loop is-enter " }),
            react_1.default.createElement("img", { className: "sme-anim-img", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/pWHv695_gift.png" }),
            react_1.default.createElement("img", { className: "sme-anim-ng", src: "https://staticintl.cloudcachetci.com/cms/backend-cms/8Qmz565_01.png" }))));
}
exports.default = AnimSme;
//# sourceMappingURL=index.js.map